import 'babel-polyfill'
import Util from './util'
import Api from './api'
import ManageJoboffers from './manage/joboffers'
import ManageRecruits from './manage/recruits'
// import Glide from '@glidejs/glide'
import Rails from 'rails-ujs'

const util = new Util()
const api = new Api()
const manageJoboffers = new ManageJoboffers()
const manageRecruits = new ManageRecruits()

class Base {
  constructor () {
    util.checkUA()
    util.setParams()
  }

  /**
   * /manage スライダーの設定
   */
  setSlide () {
    const slides = document.querySelectorAll('[data-glidenum]')
    if (slides) {
      for (let i = 0; i < slides.length; i++) {
        const glidenum = slides[i].getAttribute('data-glidenum')
        new Glide('[data-glidenum="' + glidenum + '"]', {
          type: 'slider'
        }).mount()
      }
    }
  }

  /**
   * サイドリンクのアクティブ化
   */
  actSideLink () {
    const sidelink = document.querySelector('.pbox-sidelink')
    if (sidelink) {
      const links = sidelink.querySelectorAll('a')
      const thisurl = location.pathname + location.search
      for (let i = 0; i < links.length; i++) {
        const href = links[i].getAttribute('href')
        if (href === thisurl) {
          links[i].classList.add('active')
          break
        }
      }
    }
  }

  /**
   * フォーカス時にplaceholderを削除
   */
  hidePlaceholder () {
    if (document.querySelector('form.manage_recruit_form')) {
      const tgts = document.querySelectorAll('input[type="text"], textarea')
      const cbfocus = function (self) {
        const phtmp = self.getAttribute('phtmp')
        if (!phtmp) {
          const phtxt = self.getAttribute('placeholder')
          if (phtxt) {
            self.setAttribute('phtmp', phtxt)
          }
        }

        self.setAttribute('placeholder', '')
      }

      const cbblur = function (self) {
        const phtxt = self.getAttribute('placeholder')
        if (self.value.length === 0) {
          const phtmp = self.getAttribute('phtmp')
          if (phtmp) {
            self.setAttribute('placeholder', self.getAttribute('phtmp'))
          }
        }
      }

      if (tgts) {
        util.setEventsRtSelf('focus', tgts, cbfocus.bind(this))
        util.setEventsRtSelf('blur', tgts, cbblur.bind(this))
      }
    }
  }

  /**
   * 管理画面メイン処理
   */
  main () {
    util.setTab('data-tab', 'data-tabtgt')
    manageJoboffers.getAdmasters()
    manageJoboffers.addAdspot()
    manageJoboffers.setDeleteAdspotRow()
    manageJoboffers.changeStatus()
    manageJoboffers.changeBranchOffice()
    manageJoboffers.changeAgencyPicname()
    // manageJoboffers.doneRecruitRegister()
    manageJoboffers.setCopyParam()
    manageJoboffers.doneAdspotRegister()
    manageJoboffers.calcPriceSimulation()
    // this.setSlide()
    this.actSideLink()
    manageRecruits.toggleInputs()
    manageRecruits.toggleDisable()
    manageRecruits.toggleSalary()
    manageRecruits.toggleSeminar()
    manageRecruits.submitAct()
    manageRecruits.setDeleteImg()
    manageRecruits.setDeleteTagImg()
    manageRecruits.setDefaultVal()
    manageRecruits.setPrevFrame()
    manageJoboffers.autoScroll2Tgt(util.getParams())
    util.showConfirmTxt()
    manageRecruits.setUploadChangeEv()
    manageRecruits.setTagUploadChangeEv()

    this.hidePlaceholder()
  }

  init () {
    this.main()
  }
}

const base = new Base()

document.addEventListener("DOMContentLoaded", () => {
  base.init()
})

Rails.start()
